import { ISIM_DEGISIKLIK_KONU_SORGULA } from "../constants/requestUrls";
import { getRequest } from "../request";

const isimDegisiklikKonuSorgula = () => {
    return getRequest({ url: ISIM_DEGISIKLIK_KONU_SORGULA  });
}

export default isimDegisiklikKonuSorgula;